export const getStrFileExtensions = (fileFormats: string[]): string => fileFormats.map((ext) => `.${ext}`).join(', ');
